import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getDeviceId } from './deviceId';

const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const accountDataApi = axios.create({ baseURL: API_BASE_URL });
accountDataApi.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});

function exportError(payload, fallback) {
  const error = new Error(payload?.message || payload?.error || fallback);
  error.code = payload?.data?.error_code || payload?.error_code || '';
  error.payload = payload;
  return error;
}

async function parseBlobPayload(blob) {
  try {
    const text = await blob.text();
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

function filenameFromDisposition(disposition) {
  if (!disposition) return '';
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.replace(/^"|"$/g, ''));
    } catch {
      return encoded.replace(/^"|"$/g, '');
    }
  }
  return disposition.match(/filename="?([^";]+)"?/i)?.[1] || '';
}

function fallbackFilename() {
  const now = new Date();
  const pad = value => String(value).padStart(2, '0');
  return `小影账户数据_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`;
}

export async function downloadAccountData() {
  let response;
  try {
    response = await accountDataApi.get('/account-data/export', {
      responseType: 'blob',
      validateStatus: () => true,
    });
  } catch (error) {
    const payload = error.response?.data instanceof Blob
      ? await parseBlobPayload(error.response.data)
      : error.response?.data;
    if (payload) throw exportError(payload, '账户数据导出失败，请稍后重试');
    throw error;
  }

  const contentType = String(response.headers?.['content-type'] || response.data?.type || '').toLowerCase();
  if (contentType.includes(XLSX_CONTENT_TYPE) && response.data instanceof Blob) {
    return {
      blob: response.data,
      filename: filenameFromDisposition(response.headers?.['content-disposition']) || fallbackFilename(),
    };
  }

  const payload = response.data instanceof Blob
    ? await parseBlobPayload(response.data)
    : response.data;
  throw exportError(payload, '账户数据导出失败，请稍后重试');
}

export function saveAccountDataExport({ blob, filename }) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename || fallbackFilename();
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

